import React from 'react';
import brace from 'brace';
import AceEditor from 'react-ace';

import 'brace/mode/plain_text';
import 'brace/mode/markdown';
import 'brace/mode/html';
import 'brace/mode/css';
import 'brace/mode/javascript';
import 'brace/theme/chrome';

const handleChange = (props) => (value) => {
  if (props.onChange) props.onChange({name: props.name, value});
  else console.log(props.name, value);
};

class CodeEditor extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const props = this.props;
    const mode = props.mode;
    return (
      <AceEditor
        ref="aceEditor"
        mode={mode}
        theme="chrome"
        width="100%"
        height={props.height || '300px' }
        value={props.value || ''}
        onChange={handleChange(props)}
        name={props.name}
        editorProps={{$blockScrolling: true}}
      />
    );
  }
};


// class TextEditor extends React.Component {
//   constructor(props) {
//     super(props);
//     this.props = props;
//   }
//
//   render() {
//     const props = this.props;
//     console.log('mode', props.mode)
//     return (
//       <AceEditor
//         mode={props.mode}
//         theme="chrome"
//         width="1000px"
//         height="300px"
//         value={props.value}
//         onChange={handleChange(props)}
//         name={props.name}
//         editorProps={{$blockScrolling: true}}
//       />
//     );
//   }
// }

export default CodeEditor;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/CodeEditor.jsx